/**
 * The browser tab title for the signed-in shell (plan 03 CHG-12, CHG-18): the
 * page the presenter is on, then the Auto's command center, then Supervity,
 * e.g. "Coworker Hub · Driver Recruiting Command Center | Supervity". On a
 * projector with several tabs open the page name is what tells them apart.
 *
 * Record ids in the path (a driver id, a case ref) are skipped, so a driver
 * record reads "Drivers", not a UUID. Pure and alias-free for `npm run test:unit`.
 */

/** A path segment that names a record rather than a page. */
export function isIdSegment(segment: string): boolean {
  return (
    /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(segment) ||
    /^\d+$/.test(segment) ||
    /^seed-/i.test(segment) ||
    /^[A-Z]{2,}-\d/.test(segment) ||
    (segment.length >= 20 && /\d/.test(segment))
  )
}

export function appTitle(autoName: string): string {
  return `${autoName} Command Center | Supervity`
}

export function documentTitle(
  pathname: string | null | undefined,
  labelOf: (segment: string) => string,
  rootLabel: string,
  autoName: string
): string {
  const pages = (pathname ?? '/').split('/').filter((segment) => segment && !isIdSegment(segment))
  const page = pages.length > 0 ? labelOf(pages[pages.length - 1]) : rootLabel
  return `${page} · ${appTitle(autoName)}`
}
